import { Pipe, PipeTransform, signal, untracked, WritableSignal } from '@angular/core';

@Pipe({ standalone: true, name: 'toSignal' })
export class ToSignalPipe implements PipeTransform {
  public wrappedValue = signal<any>(undefined);

  public transform<const T>(value: T): WritableSignal<T> {
    untracked(() => this.wrappedValue.set(value));
    return this.wrappedValue;
  }
}
